import { comboThreePosFixedNineteenParcelsId } from '../../variables';

export const isComboThreePosFixedNineteenParcels = (
  comboId?: number | string,
) => {
  if (!comboId) return false;
  return String(comboId) === comboThreePosFixedNineteenParcelsId;
};
